/**
 * The lists behind "What I missed" on Results (MissesPanel).
 *
 * Pure: no Phaser, so it is unit tested.
 */
import type { WordSlip } from '../types';

/** How many slipped keys the review names. */
export const KEYS_SHOWN = 8;

export interface MissedWord {
  readonly word: string;
  readonly typed: string;
  readonly times: number;
}

/** Words sent wrong, once each, with the latest attempt and how many times. */
export function missedWordsOf(slips: readonly WordSlip[]): MissedWord[] {
  const byWord = new Map<string, MissedWord>();
  for (const slip of slips) {
    if (!slip.missed) continue;
    const before = byWord.get(slip.word);
    byWord.set(slip.word, { word: slip.word, typed: slip.typed, times: (before?.times ?? 0) + 1 });
  }
  return [...byWord.values()];
}

/** Words that slipped but went in right, once each, leaving out any also sent wrong. */
export function fixedWordsOf(slips: readonly WordSlip[]): string[] {
  const missed = new Set(slips.filter((s) => s.missed).map((s) => s.word));
  return [...new Set(slips.filter((s) => !s.missed && !missed.has(s.word)).map((s) => s.word))];
}

/** "E ×3   R ×2": the keys that slipped most. */
export function trickyKeysOf(letters: Readonly<Record<string, number>>): string {
  return Object.entries(letters)
    .filter(([, count]) => count > 0)
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, KEYS_SHOWN)
    .map(([key, count]) => `${key.toUpperCase()} ×${count}`)
    .join('     ');
}

/** True when there is anything to show. */
export function hasMisses(slips: readonly WordSlip[] | undefined): boolean {
  return slips !== undefined && slips.length > 0;
}
